import React, { useState } from "react";
import Sidebar from "../../components/Sidebar";
import Header from "../../components/Header";
import "./Product.css";
import CatContent from "../../components/Product-comp/ProductContent";
import CatContentNavigation from "../../components/Product-comp/ProductContentNavigation";

const CategoryList = () => {
  const [isActive, setIsActive] = useState(false);

  return (
    <div className="col-md-12 content">
      <Sidebar
        className="sidebar-main"
        isActive={isActive}
        setIsActive={setIsActive}
        classNameTwo="open-sidebar"
      />
      <div className="col-12 sb-content">
        <div className="sb-content-header">
          <Header setIsActive={setIsActive} />
        </div>
        <div className="sb-nav">
          <CatContentNavigation />
        </div>
        <div className="content-index">
          <CatContent />
        </div>
      </div>
    </div>
  );
};

export default CategoryList;
